<template>
  <Loader v-if="!isLoaded"/>
  <div v-else>
    <div class="with-side-panel">
      <div class="content-i">
        <div class="content-box">
          <div class="element-wrapper">

            <BackButton
                :label="$t('general.button.back')"
                :to="{ name: 'unemployedNewAndActiveList' }"
                marginBottom="5"/>

            <div class="d-flex justify-content-between">
              <h6 class="element-header">
                Kunden
              </h6>

            </div>

            <div class="element-box">
              <form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput
                        v-model="formData.customerNumber"
                        :disabled="true"
                        :label="'Kundennummer'"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput
                        v-model="formData.firstName"
                        :label="'Vorname'"
                        :required="true"
                        :validation="v$?.firstName"
                        :messages="v$?.firstName?.required?.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput
                        v-model="formData.lastName"
                        :label="'Nachname'"
                        :required="true"
                        :validation="v$?.lastName"
                        :messages="v$?.lastName?.required?.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput
                        v-model="formData.address"
                        :label="'Straße'"
                        :required="true"
                        :validation="v$?.address"
                        :messages="v$?.address?.required?.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput
                        v-model="formData.zip"
                        :label="'PLZ'"
                        :required="true"
                        :validation="v$?.zip"
                        :messages="v$?.zip?.required?.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput
                        v-model="formData.city"
                        :label="'Ort'"
                        :required="true"
                        :validation="v$?.city"
                        :messages="v$?.city?.required?.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput
                        v-model="formData.email"
                        :label="'Email'"
                        :validation="v$?.email"
                        :required="true"
                        :messages="v$?.email?.isValidEmail?.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <Datepicker
                        v-model="formData.birthDate"
                        :required="true"
                        label="Geburtsdatum"
                        :validation="v$?.birthDate"
                        :messages="v$?.birthDate?.required?.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12" v-if="genderDropdown && genderDropdown.length">
                    <SelectVue
                        v-model="formData.gender"
                        :options="genderDropdown"
                        :required="true"
                        :label="$t('general.gender')"
                        :validation="v$?.gender"
                        :messages="v$?.gender?.required?.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <span
                        v-if="isAnyCustomerNumberFieldEmpty"
                        style="color: red">
                        Mindestens eine Kundennummer muss eingetragen sein
                    </span>
                    <BaseInput
                        v-model="formData.aaNumber"
                        :label="'JC / AA Nummer'"
                        :validation="v$?.aaNumber"
                        :messages="''"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                   <span
                       v-if="isAnyCustomerNumberFieldEmpty"
                       style="color: red">
                       Mindestens eine Kundennummer muss eingetragen sein
                    </span>
                    <BaseInput
                        v-model="formData.fileNumberLandscapeAssociation"
                        :label="'Aktenzeichen Landschaftsverband'"
                        :validation="v$?.fileNumberLandscapeAssociation"
                        :messages="''"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <span
                        v-if="isAnyCustomerNumberFieldEmpty"
                        style="color: red">
                        Mindestens eine Kundennummer muss eingetragen sein
                    </span>
                    <BaseInput
                        v-model="formData.insuranceNumber"
                        :label="'Versicherungsnr'"
                        :validation="v$?.insuranceNumber"
                        :messages="''"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput
                        v-model="formData.children"
                        type="number"
                        :label="'Kinder'"
                        :validation="v$?.children"
                        :messages="v$?.children?.required?.$message"/>
                  </div>

                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput
                        v-model="formData.phone"
                        :label="'Telefonnummer'"
                        :validation="v$?.phone"
                        :messages="v$?.phone?.required?.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput
                        v-model="formData.mobilePhoneNumber"
                        :label="'Nr. für Terminerinnerung (Handynummer) (Mit Ländercode +49)'"
                        :validation="v$?.mobilePhoneNumber"
                        :messages="v$?.mobilePhoneNumber?.required?.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <SelectVue
                        v-model="formData.locationId"
                        :options="officeDropdown"
                        :is-clear="true"
                        :label="'Standort'"/>
                  </div>
                  <!--                  <div class="col-lg-4 col-md-6 col-sm-12">-->
                  <!--                    <BaseInput-->
                  <!--                        v-model="formData.fileNumber61p"-->
                  <!--                        :label="'Aktenzeichen 61.P'"-->
                  <!--                        :validation="v$?.fileNumber61p"-->
                  <!--                        :messages="v$?.fileNumber61p?.required?.$message"/>-->
                  <!--                  </div>-->
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput
                        v-model="formData.placeOfBirth"
                        label="Geburtsort"/>
                  </div>
                  <!--                  <div class="col-lg-4 col-md-6 col-sm-12">-->
                  <!--                    <BaseInput-->
                  <!--                        v-model="formData.fileNumber61l"-->
                  <!--                        :label="'Aktenzeichen 61.L'"-->
                  <!--                        :validation="v$?.fileNumber61l"-->
                  <!--                        :messages="v$?.fileNumber61l?.required?.$message"/>-->
                  <!--                  </div>-->
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput
                        v-model="formData.nationality"
                        :label="'Nationalität'"
                        :validation="v$?.nationality"
                        :messages="v$?.nationality?.required?.$message"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <SelectVue
                        v-model="formData.maritalStatus"
                        :options="martialDropdown"
                        :placeholder="'Wählen Sie Familienstand'"
                        :label="'Familienstand'"
                        :isClear="true"/>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <BaseInput
                        v-model="formData.cardIK"
                        :label="'Karten IK'"
                        :validation="v$?.cardIK"
                        :messages="v$?.cardIK?.required?.$message"/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <p>AVGS Gültigkeit</p>
                    <div class="row" style="margin-top: 33px;">
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <Datepicker
                            v-model="formData.startDate"
                            label="Start"
                            :validation="v$?.startDate"
                            :messages="v$?.startDate?.required?.$message"/>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <Datepicker
                            v-model="formData.endDate"
                            label="Ende"
                            :validation="v$?.endDate"
                            :messages="v$?.endDate?.required?.$message"/>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <p>Zuzahlungsbefreiung</p>
                    <div class="row gx-2">
                      <BaseRadio
                          v-model="formData.coPaymentExemption"
                          label="Ja" name="coPaymentExemption" id="1"
                          classFormGroup="col-auto"
                          :validation="v$?.coPaymentExemption"
                          :messages="v$?.coPaymentExemption?.required?.$message"
                          :labelPosition="'right'"/>
                      <BaseRadio
                          v-model="formData.coPaymentExemption"
                          label="Nein" name="coPaymentExemption" id="0"
                          classFormGroup="col-auto"
                          :validation="v$?.coPaymentExemption"
                          :messages="v$?.coPaymentExemption?.required?.$message"
                          :labelPosition="'right'"/>
                    </div>
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <Datepicker
                            v-model="formData.coPaymentExemptionStartDate"
                            :label="false"
                            :disabled="formData.coPaymentExemption === '0'"
                            :validation="v$?.coPaymentExemptionStartDate"
                            :messages="v$?.coPaymentExemptionStartDate?.required?.$message"/>
                      </div>
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <Datepicker
                            v-model="formData.coPaymentExemptionEndDate"
                            :label="false"
                            :disabled="formData.coPaymentExemption === '0'"
                            :validation="v$?.coPaymentExemptionEndDate"
                            :messages="v$?.coPaymentExemptionEndDate?.required?.$message"/>
                      </div>
                    </div>
                  </div>
                </div>
                <hr/>

                <div class="row mt-5">
                  <div class="col-lg-4 col-md-12 col-sm-12">
                    <p>Potenzialanalyse - PDF</p>
                    <BaseDropzone
                        v-model="documentPDF"
                        :multiple="false"
                        :height="250"
                        text="Ziehen Sie Ihre Dateien hierher oder klicken Sie, um sie auszuwählen.
                        Unterstützte Formate: PDF. Maximale Dateigröße: 8 MB."/>

                    <div v-if="document1">
                      <p class="document-header">Aktuelles Document:</p>

                      <p class="mt-2 hover-underline" type="button" @click="downloadDocument(1)">
                        <i class="os-icon os-icon-download"></i>
                        <span class="document-name">{{ document1 }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-12 col-sm-12">
                    <p>CV - Word</p>
                    <BaseDropzone
                        v-model="documentWORD"
                        :multiple="false"
                        :height="250"
                        text="Ziehen Sie Ihre Dateien hierher oder klicken Sie, um sie auszuwählen.
                        Unterstützte Formate: WORD. Maximale Dateigröße: 8 MB."/>

                    <div v-if="document2">
                      <p class="document-header">Aktuelles Document:</p>

                      <p class="mt-2 hover-underline" type="button" @click="downloadDocument(2)">
                        <i class="os-icon os-icon-download"></i>
                        <span class="document-name">{{ document2 }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-12 col-sm-12">
                    <p class="mt-4 mb-0">Hier kann sowohl die Auswertung des Potenzialanalyse als auch der Lebenslauf/CV
                      des Kunden
                      hochgeladen, bzw. heruntergeladen werden. Die Dokumente sind an den Kunden gebunden, das heißt:
                      hochgeladene Dokumente sind bei allen Maßnahmen des Kundens und in dessen Kartei zu finden.</p>

                    <p class="mt-3">Potenzialanalyse: Dieses Dokument kann nur vom Standortleiter/Assistenz hochgeladen
                      und verwartet werden.Hierbei handelt es sich um ein PDF.</p>

                    <p class="mt-3">Lebenslauf/CV: Der Lebenslauf/CV kann von den zugewiesenen Coaches hochgeladen
                      werden. Zur Bearbeitung bitte immer nur Word Datein hochladen</p>

                    <p class="mt-3">WICHTIG: Es kann immer nur ein CV pro Kunde hochgeladen sein. Das erneute hochladen
                      ersätz unwiederruflich das alte Dokument.</p>
                  </div>
                </div>

                <ValidationErrorMessage :validationErrors=v$?.$errors></ValidationErrorMessage>
                <div class="d-flex justify-content-center mt-3">
                  <SaveButton
                      :label="$t('general.button.save')"
                      :loading="isSubmitting"/>
                </div>
              </form>
            </div>
          </div>
        </div>

        <Sidebar></Sidebar>
      </div>
    </div>
  </div>
</template>

<script setup>
import unemployedService from '@/api/Unemployed/index';
import BaseDropzone from '@/components/base/BaseDropzone.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseRadio from '@/components/base/BaseRadio.vue';
import CreateButton from '@/components/CreateButton.vue';
import Sidebar from '@/components/FormSidebar.vue';
import Loader from '@/components/Loader.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import ValidationErrorMessage from '@/components/ValidationErrorMessage.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
import {getOfficeDropdown} from '@/shared/dropdowns';
import {downloadFile} from '@/shared/functions';
import {isValidEmail, requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import useVuelidate from '@vuelidate/core';
import {computed, onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import BackButton from "@/components/button/BackButton.vue";
import SaveButton from "@/components/button/SaveButton.vue";

const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const {t} = useI18n();
const isLoaded = ref(false);
const genderDropdown = ref([]);
const martialDropdown = ref([]);
const officeDropdown = ref([]);
const document1 = ref('');
const document2 = ref('');
const route = useRoute();
const unemployedId = route.params.id;

const documentPDF = ref(null);
const documentWORD = ref(null);

const formData = ref({
  firstName: '',
  lastName: '',
  address: '',
  zip: '',
  city: '',
  birthDate: '',
  placeOfBirth: '',
  coPaymentExemption: '0',
  coPaymentExemptionStartDate: '',
  coPaymentExemptionEndDate: '',
  aaNumber: '',
  fileNumberLandscapeAssociation: '',
  insuranceNumber: '',
  phone: '',
  mobilePhoneNumber: '',
  email: '',
  nationality: '',
  startDate: '',
  endDate: '',
  locationId: '',
  children: 0,
  fileNumber61p: '',
  fileNumber61l: '',
  cardIK: '',
  maritalStatus: '',
  gender: 'male',
});

const formRules = computed(() => {
  const { aaNumber, insuranceNumber, fileNumberLandscapeAssociation } = formData.value

  // Common rules for all forms
  const commonRules = {
    firstName: requiredRule(t),
    lastName: requiredRule(t),
    address: requiredRule(t),
    zip: requiredRule(t),
    city: requiredRule(t),
    birthDate: requiredRule(t),
    email: isValidEmail(t),
    gender: requiredRule(t),
  }

  // If customer numbers are empty
  const customerNumbersEmpty = !aaNumber && !insuranceNumber && !fileNumberLandscapeAssociation

  return {
    ...commonRules,
    aaNumber: customerNumbersEmpty ? requiredRule(t) : '',
    insuranceNumber: customerNumbersEmpty ? requiredRule(t) : '',
    fileNumberLandscapeAssociation: customerNumbersEmpty ? requiredRule(t) : '',
  }
})

const v$ = useVuelidate(formRules, formData);

watch(() => formData.value.coPaymentExemption, (newValue) => {
  if (newValue === '0') {
    formData.value.coPaymentExemptionStartDate = '';
    formData.value.coPaymentExemptionEndDate = '';
  }
});

const isAnyCustomerNumberFieldEmpty = computed(() => {
  const {aaNumber, insuranceNumber, fileNumberLandscapeAssociation} = formData.value
  return !aaNumber && !insuranceNumber && !fileNumberLandscapeAssociation
})

const submitForm = async () => {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  try {
    const formatedForm = {...formData.value, coPaymentExemption: +formData.value.coPaymentExemption};

    const uploadData = new FormData();

    uploadData.append('body', JSON.stringify(formatedForm));

    if (documentPDF.value) {
      uploadData.append('document1', documentPDF.value[0]);
    }
    if (documentWORD.value) {
      uploadData.append('document2', documentWORD.value[0]);
    }

    if (unemployedId) {
      await unemployedService.putUnemployed(uploadData, route.params.id);
    } else {
      await unemployedService.postUnemployed(uploadData);
    }

    await router.push({name: 'unemployedNewAndActiveList'});

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
};

async function getUnemployedData() {
  try {
    const {data} = await unemployedService.getUnemployed(route.params.id);

    const customerNumber = data.data.customerNumber;
    const coPaymentExemption = String(data.data.coPaymentExemption);

    document1.value = data.data.document1;
    document2.value = data.data.document2;

    formData.value = {
      ...data.data,
      customerNumber: customerNumber,
      coPaymentExemption: coPaymentExemption,
      locationId: data.data?.location?.id
    };
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getUserEnumDropdowns() {
  genderDropdown.value = getEnums.value?.genders || [];
  martialDropdown.value = getEnums.value?.maritalStatuses || [];
}

async function getNextCustomerNumber() {
  const response = await unemployedService.getNextNumber();
  formData.value.customerNumber = response.data.data;
}

async function downloadDocument(documentNumber) {
  try {
    await downloadFile(`/unemployed/document-download/${unemployedId}/${documentNumber}`, undefined, {}, false);
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  CloseToast();

  await Promise.all([
    getUserEnumDropdowns(),
    getOfficeDropdown(officeDropdown),
  ]);

  if (unemployedId) {
    await getUnemployedData();
  } else {
    await getNextCustomerNumber();
  }
  isLoaded.value = true;
});
</script>

<style scoped>
.document-header {
  font-size: 18px;
  margin-top: 20px;
}

.hover-underline {
  color: var(--primary);
  font-size: 16px;
}

.hover-underline .hover-text:hover {
  text-decoration: underline;
}

.hover-underline i {
  font-size: 25px;
  margin-right: 15px;
}

.document-name {
  white-space: normal; /* Allow text to wrap to the next line */
  word-wrap: break-word; /* Break long words if necessary */
  overflow-wrap: break-word; /* Ensure words can break if they are too long */
}
</style>
